import UserAccessSettingsInfoModal from './UserAccessSettingsInfoModal';

export default UserAccessSettingsInfoModal;
